import { Badge } from 'DesignSystem/ui/badge';

import { useEventDetails } from '../event-detail.route';

export default function EventStatusBadge() {
  const data = useEventDetails();
  const event = data?.event;

  if (!event) {
    return null;
  }

  switch (event.status) {
    case EventStatus.ANNOUNCED:
      return <Badge className="bg-violet-200 text-violet-950">{event.status}</Badge>;
    case EventStatus.ONGOING:
      return <Badge className="bg-cyan-100 text-cyan-950">{event.status}</Badge>;
    case EventStatus.RESOLVED:
      return <Badge className="bg-zinc-200 text-zinc-800">{event.status}</Badge>;
    default:
      return <Badge variant="informative">{event.status}</Badge>;
  }
}

// TODO: Replace with enum from client/types.gen.ts, backend needs to provide

const EventStatus = {
  ANNOUNCED: 'Announced',
  ONGOING: 'Ongoing',
  RESOLVED: 'Resolved',
};
